import { APIURL } from "../../constantes.js";
import { MateriaDTO } from "../DTOS/Materia.dto.js";

export class MateriasServicio {
    async EliminarMateria(id, materia) {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/materias/${id}`, {
            body: JSON.stringify({
                materia : JSON.stringify(materia),
            }),
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "DELETE",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return [];
        }

        return respuesta.map(value => {
            const dto = new MateriaDTO();
            dto.cargarDTO(value);
            return dto;
        });
    }

    async ObtenerMaterias() {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/materias/`, {
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "GET",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return [];
        }

        return respuesta.map(value => {
            const dto = new MateriaDTO();
            dto.cargarDTO(value);
            return dto;
        });
    }

    async GuardarMateria(id, materia) {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/materias/${id}`, {
            body: JSON.stringify({
                materia : JSON.stringify(materia),
            }),
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "PUT",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return new MateriaDTO();
        }

        const dto = new MateriaDTO();
        dto.cargarDTO(respuesta);
        return dto;
    }

    async AgregarMateria(materia) {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/materias/`, {
            body: JSON.stringify({
                materia : JSON.stringify(materia),
            }),
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "POST",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return [];
        }

        return respuesta.map(value => {
            const dto = new MateriaDTO();
            dto.cargarDTO(value);
            return dto;
        });
    }

}
